import ErrorDisplay from '@platform-ui-common/components/ErrorDisplay/index.js';
import { TemporaryNewDocument } from '@platform-ui/@types/document.js';
import cx from 'classnames';
import { ReactNode, useState } from 'react';
import Color, { BackgroundColors, BorderColors, TextColors } from '../../../utilities/Color.js';
import Icon from '../../Icon/index.js';
import UnstyledButton from './UnstyledButton.js';

interface UploadButtonProps {
  id?: number | string;
  onUploadDocuments?: (docs: TemporaryNewDocument[]) => void;
  buttonText: string;
  disabled?: boolean;
  multiple?: boolean;
  hasError?: boolean;
}

export default function UploadButton({
  id,
  onUploadDocuments,
  buttonText,
  disabled,
  multiple = true,
  hasError = false,
  ...rest
}: UploadButtonProps): JSX.Element {
  const [uploadError, setUploadError] = useState<string | ReactNode>();
  return (
    <div className="flex flex-col gap-4 min-w-0">
      <UnstyledButton
        id={(id ?? '').toString()}
        className={cx(
          {
            [BorderColors[Color.Warning].toString()]: hasError || !!uploadError,
          },
          'flex gap-2 justify-center items-center border-solid border border-text rounded-xl py-1 uppercase font-semibold cursor-pointer px-4',
          BackgroundColors[Color.White],
          disabled && [TextColors[Color.TextSecondary], 'cursor-not-allowed'],
        )}
        onUploadDocuments={(docs) => {
          onUploadDocuments?.(docs);
          setUploadError(undefined);
        }}
        onUploadError={(errorMessage) => setUploadError(errorMessage)}
        disabled={disabled}
        multiple={multiple}
        hasError={hasError || !!uploadError}
        {...rest}
      >
        <Icon type="upload" size="LG" className="mr-2" />
        {buttonText}
      </UnstyledButton>
      <ErrorDisplay visible={!!uploadError} message={uploadError} />
    </div>
  );
}
